// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldWithSample {
  display: flex;
  height: auto;
  margin-bottom: 0.3em;
  width: 100%;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  gap: 0.3em;
  flex-wrap: nowrap;
}
.fieldWithSample label {
  display: flex;
  align-items: flex-end;
}
.fieldWithSample label span {
  margin-left: 0.3em;
}

.next_to_lable .fieldWithSample {
  justify-content: flex-start;
}

.char_columns .fieldWithSample {
  width: 100%;
}

.description__conteiner {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

.sku-add__container {
  display: flex;
  border-bottom: 1px solid rgba(66, 108, 166, 0.368627451);
  padding-bottom: 10px;
}
.sku-add__container label {
  width: auto;
}

.fields_check {
  margin-top: 10px;
  display: flex;
  position: relative;
  width: 100%;
  justify-content: space-around;
  gap: 20px;
}
.fields_check__images {
  display: flex;
  gap: 20px;
}
.fields_check__images__box {
  width: 230px;
  height: 210px;
}

.imb {
  width: 230px;
  height: 210px;
}

#create-sku-inKpF_btn {
  position: absolute;
  right: 1%;
}

#add-toKpF_btn {
  right: 0;
  bottom: 0;
  gap: 1em;
  justify-content: space-between;
  margin-bottom: 0.7em;
}

.input-to-right .project_input {
  justify-content: flex-end;
}

.fieldWithSample__disabled input,
.fieldWithSample__disabled textarea {
  cursor: default;
  pointer-events: none;
  opacity: 0.6;
}

.images_check_disable {
  cursor: default;
}
.images_check_disable.disable {
  cursor: default;
}
.images_check_disable.disable input {
  pointer-events: none;
  opacity: 0.6;
}

.kpf_img_box {
  background-color: white;
  width: 10em;
  height: 10em;
}

@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .kpf_button_wrapper button {
    width: 7em;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Inputs/utils/fieldWithSample.scss","webpack://./src/Components/App/vars.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;AADF;AAEE;EACE,aAAA;EACA,qBAAA;AAAJ;AACI;EACE,kBAAA;AACN;;AAIE;EACE,2BAAA;AADJ;;AAKE;EAEE,WAAA;AAHJ;;AAMA;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;AAHF;;AAKA;EACE,aAAA;EAEA,wDCvCY;EDwCZ,oBAAA;AAHF;AAIE;EACE,WAAA;AAFJ;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,SAAA;AAFF;AAKE;EACE,aAAA;EACA,SAAA;AAHJ;AAKI;EACE,YAAA;EACA,aAAA;AAHN;;AAaA;EACE,YAAA;EACA,aAAA;AAVF;;AAYA;EACE,kBAAA;EACA,SAAA;AATF;;AAWA;EAEE,QAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,oBAAA;AATF;;AAYE;EACE,yBAAA;AATJ;;AAcE;;EAEE,eAAA;EACA,oBAAA;EACA,YAAA;AAXJ;;AAeA;EACE,eAAA;AAZF;AAaE;EACE,eAAA;AAXJ;AAYI;EACE,oBAAA;EACA,YAAA;AAVN;;AAeA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;AAZF;;AAoBE;EACE;IACE,UAAA;EAjBJ;AACF","sourcesContent":["@import \"../../App/vars.scss\";\n\n.fieldWithSample {\n  display: flex;\n  height: auto;\n  margin-bottom: 0.3em;\n  width: 100%;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-direction: row;\n  gap: 0.3em;\n  flex-wrap: nowrap;\n  label {\n    display: flex;\n    align-items: flex-end;\n    span {\n      margin-left: 0.3em;\n    }\n  }\n}\n.next_to_lable {\n  .fieldWithSample {\n    justify-content: flex-start;\n  }\n}\n.char_columns {\n  .fieldWithSample {\n    // width:23em;\n    width: 100%;\n  }\n}\n.description__conteiner {\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n}\n.sku-add__container {\n  display: flex;\n  // height: 30px;\n  border-bottom: $border-thin;\n  padding-bottom: 10px;\n  label {\n    width: auto;\n  }\n}\n.fields_check {\n  margin-top: 10px;\n  display: flex;\n  position: relative;\n  width: 100%;\n  justify-content: space-around;\n  gap: 20px;\n  // align-items: flex-start;\n\n  &__images {\n    display: flex;\n    gap: 20px;\n\n    &__box {\n      width: 230px;\n      height: 210px;\n    }\n    // width: 200px;\n    // height: 200px;\n    // &_container{\n    //     width: 600px;\n    //     height: 200px;\n    // }\n  }\n}\n.imb {\n  width: 230px;\n  height: 210px;\n}\n#create-sku-inKpF_btn {\n  position: absolute;\n  right: 1%;\n}\n#add-toKpF_btn {\n  // position: absolute;\n  right: 0;\n  bottom: 0;\n  gap: 1em;\n  justify-content: space-between;\n  margin-bottom: 0.7em;\n}\n.input-to-right {\n  .project_input {\n    justify-content: flex-end;\n  }\n}\n\n.fieldWithSample__disabled {\n  input,\n  textarea {\n    cursor: default;\n    pointer-events: none;\n    opacity: 0.6;\n  }\n}\n\n.images_check_disable {\n  cursor: default;\n  &.disable {\n    cursor: default;\n    input {\n      pointer-events: none;\n      opacity: 0.6;\n    }\n  }\n}\n\n.kpf_img_box {\n  background-color: white;\n  width: 10em;\n  height: 10em;\n}\n\n// .kp_f_page {\n//   height: 20em;\n// }\n\n.kpf_button_wrapper {\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    button {\n      width: 7em;\n    }\n  }\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$accentFilterColor: #ff8040;\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
